<template>
	<div class="inf_wrap">
		<p class="back_box" @click="back()">
			<img src="../../../static/images/back.png" alt="">
			{{langtrans().fhssyy[languageIndex]}}
		</p>
		<h2>{{langtrans().xgbjjj[languageIndex]}}</h2>
		<div class="box_req">
			<h2>{{langtrans().fajbjj[languageIndex]}}</h2>
			<div class="req_box">
				<b>{{langtrans().jyfa[languageIndex]}}</b>
				<div class="acc_box">
					<div class="addfujian">
						<p @click="imgVisible=true" class="add">{{langtrans().tjfj[languageIndex]}} <span>*{{langtrans().ryyjyf[languageIndex]}},{{langtrans().qsscz[languageIndex]}}</span></p>
						<p @click="acc_list.splice(index,1)" v-for="(item,index) in acc_list" v-if="index != 0">{{item.description}}
							<span class="delete">[{{langtrans().sc[languageIndex]}}]</span></p>
					</div>
				</div>
			</div>
			<div class="baojia">
				<div class="checkedLi">
					<p><b>{{langtrans().txxbjj[languageIndex]}}</b></p>
					<div class="seleceBox" @mouseleave="seleceShow=false">
						<p @click="seleceShow=!seleceShow">{{moneyCheck}}</p>
						<ul v-show="seleceShow">
							<li v-for="item in moneyList" @click="selectFun(item)">{{languageIndex == 0?item.name : item.nameEn}} {{item.label}}</li>
						</ul>
					</div>
				</div>
				<div class="write">
					<ul>
						<li>
							<p>{{langtrans().jyfy[languageIndex]}}:</p>
							<input type="text" v-model="rescueFee" @input="upnum(rescueFee)" />
							<span>{{moneySymbol}}</span>
						</li>
						<li v-if="$route.query.typeId != 800">
							<p>{{langtrans().ylfy[languageIndex]}}:</p>
							<input type="text" v-model="medicFee" @input="upnum(medicFee)" />
							<span>{{moneySymbol}}</span>
						</li>
						<li>
							<p>{{langtrans().ajfy[languageIndex]}}:</p>
							<input type="text" v-model="caseFee" @input="upnum(caseFee)" />
							<span>{{moneySymbol}}</span>
						</li>
					</ul>
				</div>
				<div class="allMoney">
					{{langtrans().ztbtbj[languageIndex]}} :<span>{{totalFee}} {{moneySymbol}}</span>
				</div>
			</div>

			<div class="rescue_box" v-for="(item,ind) in checkList" :key="ind">
				<p><b>{{languageIndex == 0?item.name : item.nameEn}}</b></p>
				<div class="menzhenjiuyi">
					<ul>
						<li v-for="(item,index) in item.list">
							<div class="list">
								<img src="./../../assets/img/checked.png">
								<p>{{languageIndex == 0?item.dict.name : item.dict.nameEn }}</p>
								<p class="text1" v-show="item.obj.fee==-1">{{langtrans().wmxe[languageIndex]}}</p>
								<p class="text1" v-show="item.obj.fee>0">{{langtrans().xe[languageIndex]}}:{{item.obj.fee}}</p>
							</div>
							<p v-if="item.obj.description" class="text2">{{langtrans().ssym[languageIndex]}}{{languageIndex == 0 ? setTxt(item.obj.description,'zh'):setTxt(item.obj.description,'en')}}</p>
							<p v-else class="text2">{{langtrans().ssym[languageIndex]}}{{langtrans().wm[languageIndex]}}</p>
							<!-- <textarea :placeholder="langtrans().tjhf[languageIndex]" v-model="item.obj.reply"></textarea> -->
							<changeLanguage :changeText='item.obj.reply' style='margin-top: 10px;margin-left: 35px;' v-model='item.obj.reply' :btn='numberIndex'></changeLanguage>
						</li>
					</ul>
				</div>
				<div class="upbtn_box">
					<el-button type="primary" @click="flag=true;">{{langtrans().qdxgbj[languageIndex]}}</el-button>
					<span @click="back">{{langtrans().qxxg[languageIndex]}}</span>
				</div>
			</div>
		</div>
		<el-dialog :title="langtrans().qrhf[languageIndex]" :visible.sync="flag" width="30%" center>
			<p style="text-align:center">{{langtrans().sfpqrt[languageIndex]}}</p>
			<span slot="footer" class="dialog-footer">
				<el-button @click="flag = false">{{langtrans().xgyx[languageIndex]}}</el-button>
				<el-button type="primary" @click="flag = false;tooffer()">{{langtrans().q[languageIndex]}}
					{{langtrans().d[languageIndex]}}</el-button>
			</span>
		</el-dialog>
		<el-dialog :title="langtrans().ssczfa[languageIndex]" :visible.sync="imgVisible" class="img_dialog" width="50%"
		 center>
			<p><span>{{langtrans().fjmccc[languageIndex]}}</span>
				<el-input type="text" :placeholder="langtrans().ssczfa[languageIndex]" v-model="txts"></el-input>
			</p>
			<p>
				<span>
					{{langtrans().fjddz[languageIndex]}}
				</span>
				<input type="file" name="file" id="filebox" @change="handleGetFile($event)">
			</p>
			<p class="p">
				<el-button center type="button" size="small" @click="up(),imgVisible=false">{{langtrans().qd[languageIndex]}}</el-button>
			</p>
		</el-dialog>
	</div>
</template>

<script>
	import langtrans from "./js/alter.vue.trans.js";
	import qs from "qs";
	import { Message } from "element-ui";
	import "isomorphic-fetch";
	import constants from "@/util/constants.js";
	import Promise from 'promise-polyfill';
	import err from "@/util/error2msg.js";
	import changeLanguage from '@/components/common/changeLange.vue'
	if (!window.Promise) {
		window.Promise = Promise;
	}
	export default {
		data() {
			return {
        numberIndex:0,
				acc_list: [{
					url: "",
					description: "上传方案及报价"
				}],
				token: this.$route.params.token ||
					JSON.parse(window.localStorage.getItem("data")).data,
				caseid: this.$route.query.caseid,
				rescueFee: "",
				medicFee: "",
				caseFee: "",
				totalFee: "",
				formInline: {
					user: "",
					region: ""
				},
				checkList: [],
				parentObj: [],
				flag: false,
				id: 0,
				txt: [],
				data: null,
				url: "",
				txts: "",
				imgVisible: false,
				moneyList: [{
						name: '人民币',
						nameEn: 'Ren Min Bi',
						label: 'RMB'
					},
					{
						name: '美元',
						nameEn: 'U.S. Dollar',
						label: 'USD'
					},
					{
						name: '欧元',
						nameEn: 'Euro',
						label: 'EUR'
					},
					{
						name: '日元',
						nameEn: 'Japanese Yen',
						label: 'JPY'
					},
					{
						name: '新台币',
						nameEn: 'New Taiwan Currency',
						label: 'TWD'
					}
				],
				bjValue: '',
				seleceShow: false, //下拉框
				moneyCheck: '',
				moneySymbol: '',
			};
		},
		methods: {
			setTxt(str,status){
				return constants.setTxt(str,status)
			},
				langtrans(){
					return langtrans
				},
			up() {
				let flag = constants.isPic(this.url);
				if (flag) {
					this.acc_list.push({
						url: this.url,
						description: this.txts,
						icon: this.url,
					});
				} else {
					if (this.url === "") {
						Message.error("请上传附件");
					} else {
						this.acc_list.push({
							url: this.url,
							description: this.txts,
							icon: "../../../static/images/eles_icon.png"
						});
					}
				}
			},
			upnum(val) {
				if (isNaN(val)) {
					Message.error("请输入数字，而非其他");
				} else {
					console.log(this.medicFee * 1, this.caseFee * 1, this.rescueFee * 1);
					if (!this.caseFee) {
						this.caseFee = 0;
					}
					if (!this.medicFee) {
						this.medicFee = 0;
					}
					if (!this.rescueFee) {
						this.rescueFee = 0;
					}
					this.medicFee = this.medicFee * 1;
					this.caseFee = this.caseFee * 1;
					this.rescueFee = this.rescueFee * 1;
					this.totalFee = this.medicFee + this.caseFee + this.rescueFee;
				}
			},
			handleGetFile(e) {
				let that = this;
				this.file = e.target.files[0];
				this.txts = this.file.name;
				var reader = new FileReader();
				reader.readAsDataURL(this.file);
				let formdata = new FormData();
				let config = {
					headers: {
						"Content-Type": "multipart/form-data"
					}
				};
				formdata.append(
					"token",
					this.$route.params.token ||
					JSON.parse(window.localStorage.getItem("data")).data
				);
				reader.onload = function(e) {
					that.avatar = this.result;
					formdata.append("file", that.file);
					that.axios
						.post(
							constants.domain + "rescue/case/upload_file",
							formdata,
							config
						)
						.then(res => {
							that.acc_list[0].url = res.data.obj;
							that.url = res.data.obj;
						});
				};
			},
			tooffer() {
				let that = this;
				let services = [];
				let tUploadCnts = this.acc_list.slice();
				var reply='';
				tUploadCnts.shift();
				this.checkList[0].list.map((v, i) => {
					if(!constants.setTxt(v.obj.reply,'zh')){
						reply= v.obj.replyString
					}else{
						reply=v.obj.reply
					}
					services.push({
						id: that.data[i + 1].obj.id,
						serviceId: that.data[i + 1].obj.serviceId,
						description: that.data[i + 1].obj.description,
						reply
					});
				});
				if (!this.totalFee && this.totalFee == 0) {
					Message.error("请添写报价");
				} else {
					if (this.totalFee == this.rescueFee + this.caseFee + this.medicFee) {
						this.axios
							.post(
								constants.domain + "rescue/bidding/alter_bill_assist",
								qs.stringify({
									token: this.$route.params.token ||
										JSON.parse(window.localStorage.getItem("data")).data,
									caseId: this.$route.query.caseid,
									id: this.id,
									totalFee: this.totalFee,
									medicFee: this.medicFee,
									caseFee: this.caseFee,
									rescueFee: this.rescueFee,
									services: JSON.stringify(services),
									tUploadCnts: JSON.stringify(tUploadCnts),
									currency: this.moneySymbol
								})
							)
							.then(data => {
								if (data.data.code != 0) {
									var errmsg = err;
									var msg = errmsg.tomsg(data.data.code);
									Message.error(msg);
									return;
								}
								that.back();
								Message("修改成功");
							});
					} else {
						Message.error("请确认输入的数值，总价必须是其他三项之和");
					}
				}
			},
			back() {
				this.$router.push({
					name: "lookinf",
					params: {
						token: this.$route.params.token ||
							JSON.parse(window.localStorage.getItem("data")).data
					},
					query: {
						typeId: this.$route.query.typeId,
						caseid: this.$route.query.caseid
					}
				});
			},
			selectFun(item) {
				if(this.languageIndex == 0){
					this.moneyCheck = item.name + " " + item.label;
				}else{
					this.moneyCheck = item.nameEn + " " + item.label;
				}

				this.seleceShow = false;
				this.moneySymbol = item.label;
			},
			getData(){
				this.checkList=[];
				this.checkList.length=0
			let that = this;
			let n = 0;
			fetch(
					constants.domain + "rescue/bidding/view_insti_solution", {
						method: "POST",
						body: `token=${this.token}&caseId=${this.caseid}`,
						mode: "cors",
						headers: {
							"Content-Type": "application/x-www-form-urlencoded"
						}
					}
				)
				.then(function(res) {
					//console.log(res);
					return res.json();
				})
				.then(function(data) {
          setTimeout(() => {
              that.numberIndex=Math.random()
          },400)
					that.id = data.obj.id;
					that.rescueFee = data.obj.rescueFee;
					that.medicFee = data.obj.medicFee;
					that.caseFee = data.obj.caseFee;
					that.totalFee = data.obj.totalFee;
					that.data = data.obj2;

					if (data.obj.currency) {
						that.moneySymbol = data.obj.currency;
						if(that.languageIndex == 0){
							that.moneyCheck = that.moneyList.find(item => {
								return item.label == that.moneySymbol
							}).name + " " + that.moneySymbol;
						}else{
							that.moneyCheck = that.moneyList.find(item => {
								return item.label == that.moneySymbol
							}).nameEn + " " + that.moneySymbol;
						}

					} else {
						that.moneySymbol = "USD"
						that.selectFun(that.moneyList[1])
					}


					data.obj2.map(v => {
						if (v.dict.parentId == "0") {
							var obj = {};
							obj.id = v.dict.parentId;
							obj.childId = v.dict.id;
							obj.name = v.dict.name;
							obj.nameEn = v.dict.nameEn;
							obj.list = [];
							that.checkList.push(obj);
						} else {
							that.checkList.map(o => {
								if (v.dict.parentId == o.childId) {
									//console.log(v.dict.parentId)
									if(!constants.setTxt(v.obj.reply,'zh')){
										o.list.push(v);
									}else{
										v.obj.replyString=v.obj.reply;
										o.list.push(v);
									}
								}
							});
						}
					});
					fetch(constants.domain + "rescue/case/upload_cnts", {
							method: "POST",
							body: `token=${that.token}&objId=${data.obj.id}&objType=2&caseId=${that.$route.query.caseid}`,
							mode: "cors",
							headers: {
								"Content-Type": "application/x-www-form-urlencoded"
							}
						})
						.then(function(res) {
							//console.log(res);
							return res.json();
						})
						.then(function(data) {
							data.obj.map(v => {
								if (v.url !== "") {
									that.acc_list.push(v);
								}
							});
						});
				});
			}
		},

		computed: {
			languageIndex() {
				return this.$store.state.language
			}
		},
		mounted() {
			this.getData();
		},
		components:{
			changeLanguage
		},
		watch:{
			languageIndex(){
				this.getData()
			}
		}
	};
</script>

<style scoped>
	a {
		text-decoration: none;
		color: #999;
	}

	.back_box {
		text-align: left;
		font-size: 14px;
		line-height: 45px;
		color: #666;
		cursor: pointer;
	}

	.inf_wrap {
		width: 100%;
		box-sizing: border-box;
		padding: 5px 15px;
		text-align: left;
	}

	.box_req>h2 {
		font-size: 20px;
		margin-top: 5px;
		line-height: 45px;
		text-align: left;
		color: #333;
	}

	.req_box {
		box-sizing: border-box;
		padding: 0 15px;
	}

	.req_box b {
		font-size: 14px;
		color: #333;
		font-weight: 500;
	}

	.org_box {
		font-size: 16px;
		box-sizing: border-box;
		padding-left: 15px;
	}

	.org_box p {
		line-height: 40px;
		color: #333;
	}

	.acc_box {
		box-sizing: border-box;
		padding: 0 10px;
	}

	.acc_box>p {
		color: #333;
		line-height: 40px;
		font-size: 15px;
	}

	span {
		color: #df1717;
		margin-left: 2px;
	}

	.acc_box ul {
		display: flex;
	}

	.acc_box ul li {
		width: 23%;
		margin-left: 2%;
		text-align: center;
	}

	.acc_box ul li p {
		text-align: center;
		line-height: 36px;
		height: 36px;
		font-size: 14px;
	}

	.acc_box ul li img {
		margin: 0 auto;
		display: block;
		border: #999 1px solid;
		width: 90px;
		height: 120px;
	}

	.acc_box ul li a {
		color: #00abfa;
		font-size: 14px;
	}

	.el-form {
		margin-top: 15px;
	}

	.el-input {
		width: 120px;
		height: 30px;
	}

	.el-form-item__label {
		font-size: 14px;
	}

	.rescue_box {
		box-sizing: border-box;
		padding: 0 20px;
	}

	.rescue_box>p {
		line-height: 40px;
		font-size: 14px;
	}

	.res_div {
		position: relative;
		top: 18px;
	}

	.res_box {
		position: relative;
		top: 20px;
		font-size: 14px;
		color: #999;
	}

	.el-checkbox-group {
		position: relative;
		box-sizing: border-box;
		padding: 0 15px;
	}

	.el-checkbox {
		width: 100%;
		margin-bottom: 20px;
	}

	.el-checkbox+.el-checkbox {
		margin-left: 0;
	}

	.db_div,
	.res_div {
		font-size: 14px;
		color: #333;
	}

	.db_box {
		font-size: 14px;
		color: #333;
		margin-left: 30px;
	}

	.db_box b {
		color: #ff7200;
		margin-left: 8px;
	}

	.el-textarea {
		display: block;
		width: 160%;
		margin-top: 20px;
	}

	.upbtn_box {
		text-align: center;
	}

	.upbtn_box span {
		color: #00abfa;
		margin-left: 5px;
	}

	.img_dialog p {
		width: 100%;
		line-height: 48px;
	}

	.img_dialog p .el-input {
		width: 80%;
		margin-left: 3%;
	}

	.img_dialog p span {
		color: #333;
	}

	.img_dialog p input[type="file"] {
		margin-left: 3%;
	}

	.p {
		text-align: center;
	}


	.acc_box>.addfujian {
		padding: 10px 0;
	}

	.acc_box>.addfujian p {
		background: url('../../../static/images/fj.png') no-repeat left center;
		padding-left: 20px;
		cursor: pointer;
		margin-bottom: 10px;
		line-height: 30px;
	}

	.acc_box>.addfujian p.add {
		color: #00abfa;
	}

	.acc_box>.addfujian p .delete {
		color: #00abfa;
	}

	/*2018-11-24*/

	.baojia {
		margin-left: 20px;
	}

	.checkedLi {
		height: 42px;
	}

	.checkedLi p {
		float: left;
		line-height: 30px;
		font-size: 14px;
	}

	.checkedLi .seleceBox {
		float: left;
		margin-left: 10px;
	}

	.baojia .write {
		margin-left: 45px;
		overflow: hidden;
	}

	.baojia .write li {
		overflow: hidden;
		margin-top: 20px;
		float: left;
		margin-right: 50px;
		position: relative;
	}

	.baojia .write li p {
		float: left;
		line-height: 30px;
	}

	.baojia .write li input {
		float: left;
		margin-left: 10px;
		border: 1px solid #eee;
		height: 30px;
		line-height: 30px;
		color: #a0a0a0;
		border-radius: 3px;
		padding: 0 10px;
		outline: none;
		width: 150px;
	}

	.baojia .write li span {
		color: #666;
		position: absolute;
		top: 7px;
		right: 10px;
	}

	.baojia .allMoney {
		margin-left: 45px;
		margin-top: 20px;
		margin-bottom: 20px;
	}

	.baojia .allMoney span {
		color: #ff7200;
	}

	.seleceBox {
		position: relative;
		padding-bottom: 10px;
	}

	.seleceBox ul {
		position: absolute;
		top: 39px;
		left: 0;
		border: 1px solid #d9ddde;
		width: 150px;
		z-index: 2;
		background-color: white;
		border-radius: 3px;
	}

	.seleceBox p {
		width: 140px;
		height: 30px;
		line-height: 30px;
		border: 1px solid #d9ddde;
		padding-left: 10px;
		border-radius: 5px;
		font-size: 14px;
		color: #999;
		background: url('./../../assets/img/downErr.png') no-repeat 125px center;
		cursor: pointer;
	}

	.seleceBox ul li {
		line-height: 30px;
		padding-left: 10px;
		font-size: 14px;
		color: #999;
	}

	.seleceBox ul li:hover {
		background-color: #f6f6f6;
		cursor: pointer;
	}

	.menzhenjiuyi {
		margin-top: 10px;
		margin-left: 46px;
	}

	.menzhenjiuyi li {
		margin-bottom: 30px;
	}

	.menzhenjiuyi .list {
		overflow: hidden;
		margin-bottom: 5px;
	}

	.menzhenjiuyi .list * {
		float: left;
		margin-right: 10px;
	}

	.menzhenjiuyi .list img {
		height: 18px;
		margin-top: 3px;
		cursor: not-allowed;
	}

	.menzhenjiuyi textarea {
		display: block;
		width: 60%;
		margin-top: 10px;
		padding: 10px;
		height: 50px;
		border-radius: 5px;
		border: 1px solid #d9ddde;
		outline: none;
		margin-left: 33px;
	}

	.menzhenjiuyi .text1 {
		color: #df1717;
	}

	.menzhenjiuyi .text2 {
		margin-left: 33px;
		color: #999;
	}
</style>



// WEBPACK FOOTER //
// src/components/fac/alter.vue